"use strict";

var _defineProperty = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var Expander_1 = __importDefault(require("./Expander"));

var ExpansionBoxContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tborder-radius: 2px;\n"])));
var HeaderLeft = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: calc(100% - 24px);\n\tdisplay: inline-block;\n\tvertical-align: middle;\n"])));
var HeaderRight = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n"])));
var BoxHeader = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 20px;\n\ttransition: background-color ease 0.5s;\n\tbox-sizing: border-box;\n\t@media print {\n\t\tbackground-color: transparent !important;\n\t}\n"])));
var SubHeader = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tpadding-top: 15px;\n\tbox-sizing: border-box;\n\t@media print {\n\t\tbackground-color: transparent !important;\n\t}\n"])));
var BoxArrow = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t", "\n\twidth: 24px;\n\theight: 24px;\n\ttext-align: center;\n\tline-height: 24px;\n\tcursor: pointer;\n\tborder-radius: 24px;\n\t@media print {\n\t\tdisplay: none !important;\n\t}\n"])), function (props) {
  var backgroundColor = props.backgroundColor;
  return (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), backgroundColor);
});
var BoxContent = styled_1.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tpadding: 0;\n\tbox-sizing: border-box;\n"])));

var ExpansionBox = function ExpansionBox(_ref) {
  var _true$toString$toStri, _true$toString$toStri2, _true$_isOpen$toStrin;

  var header = _ref.header,
      subHeader = _ref.subHeader,
      _ref$native = _ref.native,
      native = _ref$native === void 0 ? false : _ref$native,
      _ref$headerType = _ref.headerType,
      headerType = _ref$headerType === void 0 ? "primary" : _ref$headerType,
      _ref$bodyType = _ref.bodyType,
      bodyType = _ref$bodyType === void 0 ? "primary" : _ref$bodyType,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 1000 : _ref$maxHeight,
      toggleRef = _ref.toggleRef,
      _ref$clickableHeader = _ref.clickableHeader,
      clickableHeader = _ref$clickableHeader === void 0 ? false : _ref$clickableHeader,
      children = _ref.children,
      isExpanded = _ref.isExpanded,
      _ref$urlHash = _ref.urlHash,
      urlHash = _ref$urlHash === void 0 ? "" : _ref$urlHash;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _react_1$default$useS = react_1.default.useState(true),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      init = _react_1$default$useS2[0],
      setInit = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(defaultOpen),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      _isOpen = _react_1$default$useS4[0],
      setIsOpen = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState([]),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      expanderRefs = _react_1$default$useS6[0],
      setExpanderRefs = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState((0, jsx_runtime_1.jsx)(react_1.default.Fragment, {})),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      processedChildren = _react_1$default$useS8[0],
      setProcessedChildren = _react_1$default$useS8[1];

  var cleanHeader;

  if (header.type && header.type === (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
    children: " "
  }).type) {
    var new_props = Object.assign({}, header.props);

    if (_isOpen) {
      new_props.color = theme.colors.primary.white;
      cleanHeader = (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, Object.assign({}, new_props, {
        children: header.props.children
      }));
    } else {
      cleanHeader = header;
    }
  } else {
    cleanHeader = header;
  }

  react_1.default.useEffect(function () {
    if (typeof isExpanded === "function") {
      isExpanded(_isOpen);
    }

    var newRefs = [];

    var renderElements = function renderElements() {
      var elements = react_1.default.Children.map(children, function (child, index) {
        var type = (0, jsx_runtime_1.jsx)(Expander_1.default, {}).type;

        if (child.type === type) {
          var expander = child;
          var ref = react_1.default.createRef();
          newRefs.push(ref);
          return (0, jsx_runtime_1.jsx)(Expander_1.default, {
            expanded: defaultOpen,
            expanderRef: ref,
            maxHeight: maxHeight,
            children: expander.props.children
          });
        } else {
          return child;
        }
      });
      return elements;
    };

    setExpanderRefs(newRefs);
    setProcessedChildren(renderElements());
  }, [children]); // On load child refs ,check  if url has our hash to display open

  react_1.default.useEffect(function () {
    if (expanderRefs.length > 0 && init) {
      useDeepLink() && toggleExpansionBox(true);
      setInit(false);
    }
  }, [expanderRefs]);
  react_1.default.useImperativeHandle(toggleRef, function () {
    return {
      open: function open() {
        handleClick(true);
      },
      close: function close() {
        handleClick(false);
      },
      isOpen: function isOpen() {
        return _isOpen;
      }
    };
  });

  var toggleExpansionBox = function toggleExpansionBox(expanded) {
    if (typeof isExpanded === "function") {
      isExpanded(open);
    }

    setIsOpen(expanded);

    if (expanderRefs.length > 0) {
      expanderRefs.forEach(function (ref) {
        if (expanded) ref.current.open();else ref.current.close();
      });
    }
  };

  var handleClick = function handleClick(expanded) {
    if (!!urlHash && typeof window !== "undefined") {
      !((urlHash === null || urlHash === void 0 ? void 0 : urlHash.indexOf("#")) >= 0) && (urlHash = "#" + urlHash);

      if (!_isOpen) {
        window && (window.location.hash = urlHash);
      } else if (_isOpen && window.location.hash === urlHash) {
        window && (window.location.hash = "");
      }
    }

    toggleExpansionBox(expanded);
  };

  var useDeepLink = function useDeepLink() {
    if (!!urlHash && typeof window !== "undefined") {
      !((urlHash === null || urlHash === void 0 ? void 0 : urlHash.indexOf("#")) >= 0) && (urlHash = "#" + urlHash);
      return !!urlHash && window.location.hash === urlHash;
    }
  };

  var headerColor = (_true$toString$toStri = {
    true: theme.colors.primary.darkerGray
  }, _defineProperty(_true$toString$toStri, (headerType === "primary").toString(), theme.colors.primary.background), _defineProperty(_true$toString$toStri, (headerType === "secondary").toString(), theme.colors.secondary.background), _defineProperty(_true$toString$toStri, _isOpen.toString(), theme.colors.primary.primaryBrand), _defineProperty(_true$toString$toStri, native.toString(), theme.colors.primary.header), _true$toString$toStri).true;
  var headerTextColor = (_true$toString$toStri2 = {
    true: theme.colors.primary.white
  }, _defineProperty(_true$toString$toStri2, (headerType === "primary").toString(), theme.colors.primary.text), _defineProperty(_true$toString$toStri2, (headerType === "secondary").toString(), theme.colors.secondary.text), _defineProperty(_true$toString$toStri2, _isOpen.toString(), theme.colors.primary.background), _defineProperty(_true$toString$toStri2, native.toString(), theme.colors.primary.background), _true$toString$toStri2).true;
  var iconColor = (_true$_isOpen$toStrin = {
    true: headerTextColor
  }, _defineProperty(_true$_isOpen$toStrin, _isOpen.toString(), theme.colors.primary.background), _defineProperty(_true$_isOpen$toStrin, (native && _isOpen).toString(), theme.colors.primary.background), _defineProperty(_true$_isOpen$toStrin, (native && !_isOpen).toString(), theme.colors.primary.gray), _true$_isOpen$toStrin).true;
  return (0, jsx_runtime_1.jsxs)(ExpansionBoxContainer, {
    children: [(0, jsx_runtime_1.jsxs)(BoxHeader, {
      css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\tcursor: ", ";\n\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t"])), clickableHeader === true ? "pointer" : "default", headerColor),
      onClick: function onClick() {
        if (clickableHeader === true) {
          _isOpen === true ? handleClick(false) : handleClick(true);
        }
      },
      children: [(0, jsx_runtime_1.jsx)(HeaderLeft, {
        children: cleanHeader
      }), (0, jsx_runtime_1.jsx)(HeaderRight, {
        children: (0, jsx_runtime_1.jsx)(BoxArrow, Object.assign({
          onClick: function onClick(e) {
            _isOpen === true ? handleClick(false) : handleClick(true);
            e.stopPropagation();
          },
          css: (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tborder: ", ";\n\t\t\t\t\t\t"])), native && _isOpen ? "1px solid ".concat(theme.colors.primary.link) : _isOpen ? "1px solid " + theme.colors.primary.white : "1px solid " + theme.colors.primary.darkGray)
        }, native && _isOpen ? {
          backgroundColor: theme.colors.primary.link
        } : {}, {
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: _isOpen === true ? "chevron-up" : "chevron-down",
            circled: false,
            size: "xs",
            css: (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t"]))),
            color: iconColor,
            disabled: native && !!subHeader,
            disabledColor: _isOpen ? theme.colors.primary.background : theme.colors.primary.link
          })
        }))
      }), subHeader && subHeader.length > 0 ? (0, jsx_runtime_1.jsx)(SubHeader, {
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "md",
          css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\ttransition: color ease 0.5s;\n\t\t\t\t\t\t\t\t@media print {\n\t\t\t\t\t\t\t\t\tcolor: #000000 !important;\n\t\t\t\t\t\t\t\t\ttransition: unset !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"]))),
          color: native ? theme.colors.primary.link : headerTextColor,
          children: subHeader
        })
      }) : (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {})]
    }), (0, jsx_runtime_1.jsx)(BoxContent, {
      css: (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t@media print {\n\t\t\t\t\t\tbackground-color: transparent !important;\n\t\t\t\t\t}\n\t\t\t\t"])), theme.colors[bodyType].background),
      children: processedChildren
    })]
  });
};

exports.default = ExpansionBox;